module.exports = __webpack_public_path__ + "static/media/Dolores Kitchen Bookcases (4).12b06de6.jpg";